var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoLanguageIcon = function SvgGoLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 16.5,
    fill: "currentColor",
    fontFamily: "Onest, sans-serif",
    fontSize: 11.5,
    fontWeight: 800,
    letterSpacing: -0.5,
    textAnchor: "middle"
  }, "\n\t\tGo\n\t")));
};
export default SvgGoLanguageIcon;